import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { COLORS } from '../utils/constants';
import { LINKS } from '../config/links';

const { FiBell, FiMail } = FiIcons;

const Footer = () => {
  return (
    <div className="space-y-6 mt-8">
      
      {/* Reminder CTA - ONLY ONE VERSION (nicht doppelt!) */}
      {LINKS.REMINDER_URL && (
        <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl shadow-lg p-6 text-white">
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 bg-white bg-opacity-20 rounded-full">
              <SafeIcon icon={FiBell} size={28} />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-bold">
                Nie wieder Vertragswechsel verpassen!
              </h3>
              <p className="text-sm opacity-90 mt-1">
                Lassen Sie sich automatisch erinnern, wenn Ihre Kündigungsfrist näher rückt
              </p>
            </div>
          </div>
          <a
            href={LINKS.REMINDER_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block w-full md:w-auto px-8 py-3 bg-white text-purple-600 font-bold rounded-lg shadow-lg hover:shadow-xl transition-all text-center"
          >
            Jetzt aktivieren
          </a>
        </div>
      )}

      {/* Contact for Companies */}
      <div className="bg-white rounded-xl shadow-lg p-6 border-2 border-gray-200">
        <div className="flex items-center gap-4">
          <div className="p-3 rounded-full" style={{ backgroundColor: `${COLORS.primary}20` }}>
            <SafeIcon icon={FiMail} size={24} style={{ color: COLORS.primary }} />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-bold" style={{ color: COLORS.primary }}>
              Für Unternehmen
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Sie benötigen eine individuelle Lösung oder Beratung? 
              Kontaktieren Sie uns über <a href={LINKS.HOME_URL} className="font-bold hover:underline">{LINKS.SITE_NAME}</a>
            </p>
          </div>
        </div>
      </div>

      {/* Footer Info */}
      <div className="text-center text-sm text-gray-500 py-4">
        <p>
          © {new Date().getFullYear()} {LINKS.SITE_NAME} · 
          <a href={LINKS.HOME_URL} className="hover:underline ml-1">
            Impressum & Datenschutz
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;